/**
 * Bridges the server-authenticated profile into the legacy console session,
 * then reloads so the router can rebuild from the newly persisted rights.
 */
export function completeWeComSessionBootstrap(profile, dependencies) {
  if (!profile || !profile.id) throw new Error('Missing Enterprise WeChat session profile.');

  const rights = Array.isArray(profile.rights) ? profile.rights : [];
  const isWorkbenchEntry = dependencies.entry === 'workbench';
  // Home route keys affect only client-side route registration, not business authorization.
  const menuRights =
    !profile.isSuperAdmin && isWorkbenchEntry
      ? [...new Set([...rights, 'home', 'first'])]
      : profile.isSuperAdmin
        ? []
        : rights;
  dependencies.userInfoStorage.set(profile);
  dependencies.authorizationStorage.set(rights);
  dependencies.menuRightsStorage.set(menuRights);
  dependencies.xTokenStorage.set(profile.id);

  // Landing targets are a closed mapping; query values are never treated as URLs.
  if (isWorkbenchEntry) {
    dependencies.location.hash = '#/home/first';
  } else if (dependencies.entry === 'optical-list') {
    dependencies.location.hash = '#/member/opticalResultList';
  } else if (dependencies.entry === 'optical-review') {
    const uploadId = String(dependencies.uploadId || '');
    const isValidUploadId = /^[1-9]\d*$/.test(uploadId);
    dependencies.location.hash = isValidUploadId && typeof dependencies.encodeUploadId === 'function'
      ? `#/member/opticalResultDetails?uploadId=${dependencies.encodeUploadId(uploadId)}`
      : '#/member/opticalResultList';
  } else {
    dependencies.location.hash = '#/order/orderList';
  }
  dependencies.location.reload();
}

export async function validateWeComSession(profile, loadCurrentSession) {
  if (!profile || profile.authenticationMethod !== 'wecom') return true;

  try {
    const currentSession = await loadCurrentSession();
    return Boolean(currentSession && currentSession.id === profile.id);
  } catch (_error) {
    return false;
  }
}

export function clearLegacyBackofficeSession(dependencies) {
  dependencies.userInfoStorage.remove();
  dependencies.authorizationStorage.remove();
  dependencies.menuRightsStorage.remove();
  dependencies.xTokenStorage.remove();
}
